import type { BillingLarkEvent, BillingLarkEventKey } from '@/hooks/use-platform-billing-lark'

/** Chỉ các công tắc sự kiện KHÁC giá trị đã lưu — gửi lên server đúng phần thay đổi. Hàm thuần, có test. */
export function changedEvents(
  saved: BillingLarkEvent[], draft: Partial<Record<BillingLarkEventKey, boolean>>,
): Partial<Record<BillingLarkEventKey, boolean>> {
  const out: Partial<Record<BillingLarkEventKey, boolean>> = {}
  for (const e of saved) {
    const v = draft[e.key]
    if (typeof v === 'boolean' && v !== e.enabled) out[e.key] = v
  }
  return out
}
